import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";

interface AiOffBottomSheetProps {
  open: boolean;
  isOwner: boolean;
  enabling: boolean;
  onEnableAi: () => Promise<void>;
  onCancel: () => void;
}

export function AiOffBottomSheet({ open, isOwner, enabling, onEnableAi, onCancel }: AiOffBottomSheetProps) {
  const title = isOwner
    ? "AI is turned off in this space"
    : "Mori's magic is turned off";
  const body = isOwner
    ? "We can't process this with AI right now. Turn it on for new memories, or cancel."
    : "The space owner has turned off AI processing. Ask them to enable it if you'd like Mori to help with this memory.";

  return (
    <Sheet open={open} onOpenChange={(v) => !v && onCancel()}>
      <SheetContent
        side="bottom"
        className="z-[60] rounded-t-3xl px-6 pt-6 pb-10"
        overlayClassName="z-[60]"
        hideCloseButton
      >
        <SheetTitle className="sr-only">{title}</SheetTitle>

        <div className="flex flex-col items-center gap-4 text-center">
          <h2
            className="text-foreground"
            style={{ fontSize: 15, fontWeight: 500 }}
          >
            {title}
          </h2>

          <p
            className="text-muted-foreground max-w-[280px]"
            style={{ fontSize: 13, lineHeight: 1.5 }}
          >
            {body}
          </p>

          <div className="flex flex-col gap-2 w-full pt-1">
            {isOwner ? (
              <>
                <Button
                  onClick={onEnableAi}
                  disabled={enabling}
                  className="w-full h-11"
                >
                  {enabling ? "Turning on…" : "Turn AI on"}
                </Button>
                <button
                  type="button"
                  onClick={onCancel}
                  className="text-xs text-muted-foreground hover:text-foreground transition-colors py-2"
                >
                  Cancel
                </button>
              </>
            ) : (
              <Button
                onClick={onCancel}
                className="w-full h-11"
              >
                Got it
              </Button>
            )}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
